<template>
    <layout v-bind:user="user" v-bind:brands="brands" v-bind:shops="shops" v-bind:company="company" v-bind:title="pageName">
        <main class="ly_main"><div class="wrap"><div class="inner">
            <!--Heading-->
            <h1 class="heading_page-title flex _y-center">
                <div v-if="user.type != 0" class="main"><span>{{ pageName }}</span></div>
                <div v-if="user.type == 0" class="main"><span>{{select_company.name}}の{{ pageName }}</span></div>
                <div class="controller flex _right _y-center">
                    <div class="form_search">
                        <form v-on:submit.prevent="search">
                            <input type="search" v-model="free_text">
                            <label for="submit-btn" class="md_svg-icon">
                                <SvgIconSearch />
                            </label>
                            <input type="submit" id="submit-btn">
                        </form>
                    </div><!--/.search-->
                    <div v-if="user.type !== 0 && !getPersonalPlan">
                        <a class="btn_link md_icon-text" :href="route(routeLink)">
                            <div class="inner">
                            <span>
                                新規追加
                                <div class="icon">
                                    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 17C11 15.3431 12.3431 14 14 14H86C87.6569 14 89 15.3431 89 17V46.2131C89 47.87 87.6569 49.2131 86 49.2131H79.1817V83C79.1817 84.6569 77.8385 86 76.1817 86H23.8181C22.1612 86 20.8181 84.6569 20.8181 83V49.2131H14C12.3431 49.2131 11 47.87 11 46.2131V17ZM17 20V43.2131H23.8181C25.4749 43.2131 26.8181 44.5563 26.8181 46.2131V80H73.1817V46.2131C73.1817 44.5563 74.5248 43.2131 76.1817 43.2131H83V20H17Z" fill="white"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M31.7278 18.082C32.454 27.2954 40.2454 34.4949 49.6793 34.4949C59.1133 34.4949 66.9047 27.2954 67.6309 18.082H61.6016C60.8957 23.9201 55.8569 28.4949 49.6793 28.4949C43.5018 28.4949 38.463 23.9201 37.7571 18.082H31.7278Z" fill="white"/>
                                    </svg>
                                </div>
                            </span>
                        </div></a>
                    </div><!--/.add-->
                    <div v-if="!getPersonalPlan && displayLists.length">
                        <a class="btn_link md_icon-text" v-on:click="collectDelete()">
                            <div class="inner">
                            <span>
                                まとめて削除
                                <div class="icon">
                                    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M25.1042 36.3709H75.1251L72.9502 85.18H27.279L25.1042 36.3709Z" stroke="white" stroke-width="4"/>
                                    <rect width="60.2292" height="13.2191" transform="matrix(1 0 0 -1 20 36.3709)" stroke="white" stroke-width="4"/>
                                    <rect x="43.4792" y="14" width="14.2917" height="9.15172" stroke="white" stroke-width="4"/>
                                    <path d="M58.7917 85.18V59.7585M42.4584 85.18V51.1152" stroke="white" stroke-width="4"/>
                                    </svg>
                                </div>
                            </span>
                        </div></a>
                    </div><!--/.add-->
                </div><!--/.controller-->
            </h1><!--/.heading_page-title-->
            <div class="md_common-bl" id="bland-list">
                <div class="inner">
                    <div class="table_common _use-checkbox">
                        <table>
                            <thead>
                                <tr>
                                    <th class="form_checkbox" v-if="!getPersonalPlan">
                                        <input type="checkbox" name="checkbox1" id="checkbox-all" v-on:change="changeAllCheckBox()">
                                        <label for="checkbox-all"></label>
                                    </th>
                                    <th class="_pointer" @click="clickSort('name')">{{ itemName }}{{getTriangle('name')}}</th>
                                    <th class="_pointer" v-if="userType == 'brand' || userType == 'showroom'" @click="clickSort('plan')">プラン  {{getTriangle('plan')}}</th>
                                    <th class="_pointer" @click="clickSort('status')">ステータス {{getTriangle('status')}}</th>
                                    <th class="_pointer" @click="clickSort('approval')">承認 {{getTriangle('approval')}}</th>
                                    <th class="icon"></th>
                                </tr>
                            </thead>
                            <tbody v-if="userType == 'brand' || userType == 'showroom'">
                                <!--Item-->
                                <tr v-for="(list, index) in displayLists" :key="index">
                                    <td class="form_checkbox" v-if="!getPersonalPlan">
                                        <input type="checkbox" name="checkbox1" :id="'checkbox1-' + (index + 1)">
                                        <label :for="'checkbox1-' + (index + 1)"></label>
                                    </td>

                                    <td v-if="userType == 'brand'">
                                        <a class="" :href="route('admin.brand.detail', list.id)">
                                            {{list.name}}
                                        </a>
                                    </td>
                                    <td v-if="userType == 'showroom'">
                                        <a class="" :href="route('admin.showroom.detail', list.id)">
                                            {{list.name}}
                                        </a>
                                    </td>

                                    <td v-if="userType == 'brand'">
                                        {{list.plan_name}}
                                        <a class="btn_svg-icon" :href="route('admin.brand.pay.show', list.id)" v-if="((user.role === 0 && list.approval === 1) || (user.type === 0 && list.approval === 1)) && list.demo_plan == 0">
                                            <SvgIconEdit />
                                        </a>
                                        <template v-if="list.plan_grace_period_time">
                                            <span style="font-size: x-small;"> ※{{formatDate(list.plan_grace_period_time)}}まで</span>
                                        </template>
                                    </td>
                                    <td v-if="userType == 'showroom'">
                                        {{list.plan_name}}
                                        <a class="btn_svg-icon" :href="route('admin.showroom.pay.show', list.id)" v-if="((user.role === 0 && list.approval === 1) || (user.type === 0 && list.approval === 1)) && list.demo_plan == 0">
                                            <SvgIconEdit />
                                        </a>
                                        <template v-if="list.plan_grace_period_time">
                                            <span style="font-size: x-small;"> ※{{formatDate(list.plan_grace_period_time)}}まで</span>
                                        </template>
                                    </td>

                                    <td>
                                        <select v-on:change="changeStatus($event, list)" v-bind:disabled="list.approval != 1" v-model="list.status">
                                            <option v-for="s in status"
                                                v-bind:value="s.id"
                                                v-bind:key="s.id">
                                                {{ s.name }}
                                            </option>
                                        </select>
                                    </td>

                                    <template v-if="pageType != 3">
                                        <td v-if="list.approval == 0"><Link class="" :href="route(getRouteName, list.id)">審査待ち</Link></td>
                                        <td v-else-if="list.approval == 1"><Link class="" :href="route(getRouteName, list.id)">承認済</Link></td>
                                        <td v-else-if="list.approval == 2"><Link class="" :href="route(getRouteName, list.id)">非承認</Link></td>
                                    </template>
                                    <template v-if="pageType == 3">
                                        <template v-if="user.type != 0">
                                            <td v-if="list.approval == 0">審査待ち</td>
                                            <td v-else-if="list.approval == 1">承認済</td>
                                            <td v-else-if="list.approval == 2">非承認</td>
                                        </template>
                                        <template v-if="user.type == 0">
                                            <td>
                                                <select v-on:change="selectApproval($event, list)">
                                                    <option value="" hidden>審査待ち</option>
                                                    <option v-for="select_approval in select_approvals" v-bind:selected="select_approval.id == list.approval" v-bind:key="select_approval.id" v-bind:value="select_approval.id">{{ select_approval.name }}</option>
                                                </select>
                                            </td>
                                        </template>
                                    </template>

                                    <th class="icon" v-if="userType == 'brand'">
                                        <a class="btn_svg-icon" :href="route('admin.brand.detail', list.id)">
                                            <SvgIconEdit />
                                        </a>
                                    </th>
                                    <th class="icon" v-if="userType == 'showroom'">
                                        <a class="btn_svg-icon" :href="route('admin.showroom.detail', list.id)">
                                            <SvgIconEdit />
                                        </a>
                                    </th>

                                </tr><!--/.Item-->
                            </tbody>
                            <tbody v-if="userType == 'shop'">
                                <!--Item-->
                                <tr v-for="(list, index) in displayLists" :key="index">
                                    <td class="form_checkbox" v-if="!getPersonalPlan">
                                        <input type="checkbox" name="checkbox1" :id="'checkbox1-' + (index + 1)">
                                        <label :for="'checkbox1-' + (index + 1)"></label>
                                    </td>
                                    <td>
                                        <a class="" :href="route('admin.shop.detail', list.id)">
                                            {{list.name}}
                                        </a>
                                    </td>
                                    <td>
                                        <select v-on:change="changeStatus($event, list)" v-bind:disabled="list.approval != 1" v-model="list.status">
                                            <option v-for="s in status"
                                                v-bind:value="s.id"
                                                v-bind:key="s.id">
                                                {{ s.name }}
                                            </option>
                                        </select>
                                    </td>
                                    <template v-if="pageType != 3">
                                        <td v-if="list.approval == 0"><Link class="" :href="route(getRouteName, list.id)">審査待ち</Link></td>
                                        <td v-else-if="list.approval == 1"><Link class="" :href="route(getRouteName, list.id)">承認済</Link></td>
                                        <td v-else-if="list.approval == 2"><Link class="" :href="route(getRouteName, list.id)">非承認</Link></td>
                                    </template>
                                    <template v-if="pageType == 3">
                                        <td v-if="list.approval == 0">審査待ち</td>
                                        <td v-else-if="list.approval == 1">承認済</td>
                                        <td v-else-if="list.approval == 2">非承認</td>
                                    </template>
                                    <th class="icon">
                                        <a class="btn_svg-icon" :href="route('admin.shop.detail', list.id)">
                                            <SvgIconEdit />
                                        </a>
                                    </th>
                                </tr><!--/.Item-->
                            </tbody>
                        </table>
                        <pagination v-if="showPagination" :list="links" />
                </div><!--/.table_common-->
            </div><!--/.md_common-bl-->
            <AlertModal
                v-if="showAlertModal"
                @close="closeAlertModal"
                :title="alert_modal_title"
                :message="alert_modal_message"
                :mode="alert_modal_mode"
            />
            <ConfirmModalWithPromise ref="confirmModal" />
        </div></div></div><div class="heading_page-title-en"><span>{{backName}}</span></div></main>
    </layout>
</template>

<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import Pagination from '@/components/Admin/Pagination'
    import AlertModal from '@/components/Admin/ComponentList/AlertModal'
    import ConfirmModalWithPromise from '@/components/Admin/ComponentList/ConfirmModalWithPromise'
    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'
    import { Link } from '@inertiajs/inertia-vue3'
    import dayjs from 'dayjs'

    //Svg
    import SvgIconSearch from '@/components/EndUser/svg/SvgIconSearch'
    import SvgIconEdit from '@/components/EndUser/svg/SvgIconEdit'
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'

    import ScrollHint from 'scroll-hint';

    export default {
        components: {
            "layout": AdminLayout,
            "pagination": Pagination,
            "Link": Link,
            "AlertModal": AlertModal,
            "ConfirmModalWithPromise": ConfirmModalWithPromise,
            "ScrollHint": ScrollHint,
            //Svg
            SvgIconSearch,
            SvgIconEdit,
            SvgIconDelete,
        },
        props:{
            user: Object,
            company: Object,
            brands: {
                type: Array,
            },
            shops: {
                type: Array,
            },
            brands_list: Object,
            shops_list: Object,
            freeText: Object,
            companyId: Object,
            select_company: Object,
            listSorter: Object,
        },
        data() {
            return {
                //ブランドリストのループ
                //課金履歴のループ
                billingHistorys: [
                    { planName : "Basic", licenceStatus: "買い切り", dayStart: "2021.10.04", dayEnd: "2021.10.31", planPrice: "4,950"},
                    { planName : "Basic", licenceStatus: "月間", dayStart: "2021.10.04", dayEnd: "2021.10.31", planPrice: "4,950"},
                    { planName : "Free", licenceStatus: "-", dayStart: "2021.10.04", dayEnd: "2021.10.31", planPrice: "0"},
                    { planName : "Basic", licenceStatus: "年間", dayStart: "2021.10.04", dayEnd: "2021.10.31", planPrice: "4,950"},
                ],
                displayLists: [],
                userType: '',
                pageName: '',
                itemName: '',
                showPagination: false,
                free_text: '',
                links: '',
                showAlertModal: false,
                alert_modal_title: '',
                alert_modal_message: '',
                alert_modal_mode: '',
                list_sorter: {column: "", order: ""},
                status: [
                    { id: 0, name: "非公開"},
                    { id: 1, name: "公開"}
                ],
                select_approvals: [
                    { id: 1, name: '承認'},
                    { id: 2, name: '非承認'},
                ],
            }
        },
        created() {
            this.setDefaultData();
        },
        mounted(){
            if(this.$page.props.flash.success?.length > 0){
                const successMessage = this.$page.props.flash.success.split(",");
                this.openAlertModal("success", successMessage[0], successMessage[1]);
            };
            new ScrollHint('.table_common');
        },
        methods: {
            formatDate: dateStr => dayjs(dateStr).format('YYYY/MM/DD'),
            setDefaultData() {
                switch (this.pageType) {
                    case 3:
                        this.userType = 'showroom';
                        this.pageName = 'ShowRoom';
                        this.itemName = 'ショールーム名';
                        this.displayLists = this.setDisplayLists(this.brands_list.data);
                        if (this.brands_list.data) {
                            this.showPagination = true;
                        }
                        this.links = this.brands_list;
                        for(var i in this.brands_list.links) {
                            var link = this.brands_list.links[i];
                            if (this.freeText) {
                                link.url = link.url + '&freeText=' + this.freeText;
                            }
                            if (this.companyId) {
                                link.url = link.url + '&company_id=' + this.companyId;
                            }
                        }
                        if (this.listSorter) {
                            this.addSorterToLinks(this.listSorter, this.brands_list.links);
                        }
                        break;
                    case 2:
                        this.userType = 'brand';
                        this.pageName = 'Brand';
                        this.itemName = 'ブランド名';
                        this.displayLists = this.setDisplayLists(this.brands_list.data);
                        if (this.brands_list.data) {
                            this.showPagination = true;
                        }
                        this.links = this.brands_list;
                        for(var i in this.brands_list.links) {
                            var link = this.brands_list.links[i];
                            if (this.freeText) {
                                link.url = link.url + '&freeText=' + this.freeText;
                            }
                            if (this.companyId) {
                                link.url = link.url + '&company_id=' + this.companyId;
                            }
                        }
                        if (this.listSorter) {
                            this.addSorterToLinks(this.listSorter, this.brands_list.links);
                        }
                        break;
                    case 1:
                        this.userType = 'shop';
                        this.pageName = 'Shop';
                        this.itemName = 'ショップ名';
                        this.displayLists = this.setDisplayLists(this.shops_list.data);
                        if (this.shops_list.data) {
                            this.showPagination = true;
                        }
                        this.links = this.shops_list;
                        for(var i in this.shops_list.links) {
                            var link = this.shops_list.links[i];
                            if (this.freeText) {
                                link.url = link.url + '&freeText=' + this.freeText;
                            }
                            if (this.companyId) {
                                link.url = link.url + '&company_id=' + this.companyId;
                            }
                        }
                        if (this.listSorter) {
                            this.addSorterToLinks(this.listSorter, this.shops_list.links);
                        }
                        break;
                }
                this.free_text = this.freeText;
                if(this.listSorter){
                    this.list_sorter = this.listSorter;
                }
            },
            setDisplayLists(data) {
                var list = [];
                for (var i in data) {
                    switch (data[i].plan) {
                        case 0:
                            data[i].plan_name = 'free';
                            break;
                        case 1:
                            data[i].plan_name = 'basic';
                            break;
                        case 2:
                            data[i].plan_name = 'premium';
                            break;
                        case 10:
                            data[i].plan_name = 'personal';
                            break;
                        case 11:
                            data[i].plan_name = 'unit';
                            break;
                    }
                    list.push(data[i]);
                }
                return list;
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = '';
                this.alert_modal_title = '';
                this.alert_modal_message = '';
            },
            search() {
                var url = location.pathname;
                const form = reactive({
                    freeText: this.free_text,
                    company_id: this.companyId,
                    listSorter: this.list_sorter
                })
                Inertia.get(url, form, {
                    onSuccess: (page) => {
                        this.free_text = '';
                    },
                })
            },
            async changeStatus(event, target) {
                var value = event.target.value;
                var prevStatus = '';
                var afterStatus = '';
                if (value == 0) {
                    prevStatus = '公開';
                    afterStatus = '非公開';
                } else if (value == 1) {
                    prevStatus = '非公開';
                    afterStatus = '公開';
                }
                const message = target.name + ' を ' +  prevStatus + ' から ' + afterStatus + ' に変更しますか？';
                const confirm = await this.$refs.confirmModal.show({ // 確認済み
                    title: '変更しますか？',
                    message: message,
                    mode: "confirm",
                    name: "listConfirm"
                })
                if (confirm) {
                    var routeName = '';
                    if (this.pageType == 1) {
                        routeName = 'admin.shop.change.status';
                        var data = reactive({
                            shop_id: target.id,
                            status: value,
                            company_id: this.companyId,
                        });
                    } else if (this.pageType == 2) {
                        routeName = 'admin.brand.change.status';
                        var data = reactive({
                            brand_id: target.id,
                            status: value,
                            company_id: this.companyId,
                        });
                    } else if (this.pageType == 3) {
                        routeName = 'admin.showroom.change.status';
                        var data = reactive({
                            brand_id: target.id,
                            status: value,
                            company_id: this.companyId,
                        });
                    }
                    Inertia.post(route(routeName), data, {
                        preserveScroll: true,
                        onError: (errors) => {
                            this.openAlertModal('error', 'エラー', errors); // 確認済み
                        },
                        onSuccess: visit => {
                            const successMessage = target.name + ' を ' +  prevStatus + ' から ' + afterStatus + ' に変更しました。';
                            this.openAlertModal('success', '変更しました', successMessage); // 確認済み
                        },
                        onFinish: visit => {
                        },
                    })
                } else {
                    location.reload();
                }
            },
            changeAllCheckBox(){
                let all_element = document.getElementById('checkbox-all');
                let input_name = 'input[name=checkbox1]';

                if (all_element.checked) {
                    $(input_name).prop('checked', true);
                } else {
                    $(input_name).prop('checked', false);
                }
            },
            async collectDelete(){
                let deleteItems = [];
                let plan_check = true;

                for(let i in this.displayLists) {
                    let displayList = this.displayLists[i];
                    let index = parseInt(i) + 1;
                    let element = document.getElementById('checkbox1-' + index);
                    if (element.checked) {
                        // basicプラン
                        if (displayList.plan == 1 && displayList.subscription_status == 'active') {
                            plan_check = false;
                        }
                        deleteItems.push(displayList);
                    }
                }
                if (!plan_check) {
                    this.openAlertModal('error', 'プランのキャンセルが必要です', '選択されたブランドの中にお支払い中のbasicプランがあります。削除するにはプランのキャンセルが必要です。'); //確認済み
                    return;
                }
                if (deleteItems.length) {
                    const confirm = await this.$refs.confirmModal.show({ // 確認済み
                        title: '削除してもよろしいですか？',
                        message: '本当に削除してもよろしいですか？',
                        mode: "confirm",
                        name: "listConfirm"
                    })
                    if (confirm) {
                        if (this.pageType == 1) {
                            var routeName = 'admin.shop.delete';
                            var name = 'ショップ';
                        } else if (this.pageType == 2) {
                            var routeName = 'admin.brand.delete';
                            var name = 'ブランド';
                        } else if (this.pageType == 3) {
                            var routeName = 'admin.showroom.delete';
                            var name = 'ショールーム';
                        }
                        let form_data = reactive({
                            delete_items: deleteItems,
                            select_company: this.select_company,
                        });
                        Inertia.post(route(routeName), form_data, {
                            onSuccess: visit => {
                                this.openAlertModal('success', '削除しました', '選択された'+ name + 'を削除しました'); //確認済み
                                setTimeout(function() { location.reload(); }, 2000); // modalを見る時間確保
                            },
                        })
                    }
                }
            },
            clickSort(sorter){
                if(this.list_sorter.column !== sorter){ // 1回目クリックされたらascでソート
                    this.list_sorter.column = sorter;
                    this.list_sorter.order = "ASC";
                } else {
                    if(this.list_sorter.order == "ASC"){
                        this.list_sorter.order = "DESC"; // 2回目クリックされたらdescでソート
                    } else {
                        this.list_sorter.column = ""; // 3回目クリックされたらソートを外す
                        this.list_sorter.order = "";
                    }
                }
                const { column, order } = this.list_sorter;
                const form = reactive({
                    freeText: this.free_text,
                    listSorter: { column, order },
                    company_id: this.companyId,
                })
                Inertia.get(location.pathname, form);
            },
            addSorterToLinks(sorter, links){
                for(var i in links) {
                    var link = links[i];
                    if (link.url) {
                        link.url = link.url + `&listSorter[column]=${sorter.column}&listSorter[order]=${sorter.order}`;
                    }
                }
            },
            getTriangle(name){
                if(name == this.list_sorter.column){
                    return this.list_sorter.order == "ASC" ? "▼" : "▲";
                } else return "▼";
            },
            selectApproval(event, item) {
                var selectApprovalId = event.target.value;
                var id = item.id
                var url = '/admin/showroom/price-zone'

                const form = reactive({
                    id: id,
                    approval: selectApprovalId,
                    company_id: this.companyId,
                })
                Inertia.post(url, form, {
                    onSuccess: (page) => {
                        console.log(selectApprovalId);
                        if (selectApprovalId == 1) {
                            this.openAlertModal("success", '承認しました', '承認しました。'); // 確認済み
                        } else {
                            this.openAlertModal("success", '承認しませんでした', '承認しませんでした。'); // 確認済み
                        }
                    },
                })
            },
        },
        computed: {
            routeLink() {
                if (location.pathname == '/admin/brand') { //ブランド ブランド一覧の場合
                    return 'admin.brand.detail';
                } else if (location.pathname == '/admin/shop') { //ショップ ショップ一覧の場合
                    return 'admin.shop.detail';
                } else if (location.pathname == '/admin/showroom') { //ショールーム ショールーム一覧の場合
                    return 'admin.showroom.detail';
                }
            },
            backName() {
                if (this.user.type == 0) {
                    return 'Admin';
                } else if (this.user.type == 1) {
                    return 'Shop';
                } else if (this.user.type == 2) {
                    return 'Brand';
                } else if (this.user.type == 3) {
                    return 'ShowRoom';
                }
            },
            pageType() {
                if (location.pathname == '/admin/shop') {
                    //ショップ 自ショップ一覧の場合
                    return 1;
                } else if (location.pathname == '/admin/brand') {
                    //ブランド 自ブランド一覧の場合
                    return 2;
                } else if (location.pathname == '/admin/showroom') {
                    //ショールーム 自ショールーム一覧の場合
                    return 3;
                }
            },
            getRouteName() {
                if (location.pathname == '/admin/brand') {
                    return 'admin.brand.price.zone';
                } else if (location.pathname == '/admin/shop') {
                    return 'admin.shop.price.zone';
                }
            },
            getPersonalPlan() {
                if (location.pathname == '/admin/brand') {
                    return false;
                }
                if (this.displayLists.length) {
                    // shop [10:personal | 11: unit ]
                    // brand [ 0:無料 | 1:BASIC | 2: premium ]
                    if (this.displayLists[0].plan == 10) {
                        return true;
                    }  else if (this.displayLists[0].plan == 11) {
                        return false;
                    }
                } else {
                    // 0になる可能性があるのは削除機能のあるshop側ではunitだけ
                    return false;
                }
            },
        },
    }
</script>
